import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SubstanceTypeEnum } from 'app/enums/substance-type-enum';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-code-designations',
  templateUrl: './code-designations.component.html',
  styleUrls: ['./code-designations.component.scss']
})
export class CodeDesignationsComponent implements OnInit {
  @Input({required: true}) substanceType!: SubstanceTypeEnum;
  @Input() shouldShowFullTitle!: boolean; // Only if single entity/salt shouldn't be displayed on their respective pages.
  codeDesignations!: string;
  formType !: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.codeDesignations = this.currentFormValue;
    this.formType = this.currentForm.get('formType')?.value;
  }

  public clearCodeDesignationsInputField() {
    this.codeDesignations = '';
    this.patchValueToCurrentForm('');
    this.errorCheck();
  }

  public updateCodeDesignations(event: Event) {
    if (event && event.type === 'blur') {
      var target = document.activeElement;
      if (target && target.nodeValue === "cancel") {
        this.codeDesignations = '';
      }
    }
    this.patchValueToCurrentForm(this.codeDesignations);
    this.errorCheck();
  }

  public cancelUpdate() {
    this.codeDesignations = this.currentFormValue;
    this.errorCheck();
  }

  get currentFormValue() {
    if(this.isNoneRegistryNumberInputType || this.isBiologicsInputType) {
      return this.currentForm.get('codeDesignations')?.value;
    }

    if(this.isSingleEntityRegistryNumberInputType) {
      return this.currentForm.get('codeDesignationsForSingleEntity')?.value; 
    }
    if(this.isSaltRegistryNumberInputType) {
      return this.currentForm.get('codeDesignationsForSaltForm')?.value; 
    }
    
    return '';
  }

  private patchValueToCurrentForm(value: string) {
    this.currentForm.patchValue({ [this.formFieldName] : value });
  }

  get isNoneRegistryNumberInputType() {
    return this.substanceType === SubstanceTypeEnum.None;
  }

  get isSingleEntityRegistryNumberInputType() {
    return this.substanceType === SubstanceTypeEnum.SingleEntity;
  }

  get isSaltRegistryNumberInputType() {
    return this.substanceType === SubstanceTypeEnum.Salt;
  }

  get isBiologicsInputType() {
    return this.substanceType === SubstanceTypeEnum.Biologics;
  }

  get formFieldName() {
    if(this.isNoneRegistryNumberInputType || this.isBiologicsInputType) {
      return 'codeDesignations';
    }

    if(this.isSingleEntityRegistryNumberInputType) {
      return 'codeDesignationsForSingleEntity'; 
    }
    if(this.isSaltRegistryNumberInputType) {
      return 'codeDesignationsForSaltForm'; 
    }

    return '';
  }

  get formFieldTitle() {
    var title = 'Code designation(s)';

    if(this.isSingleEntityRegistryNumberInputType && this.shouldShowFullTitle) {
      title += ' for single entity'; 
    }
    if(this.isSaltRegistryNumberInputType && this.shouldShowFullTitle) {
      title += ' for salt form'; 
    }

    return title;
  }

  private errorCheck() {
    const targetControl = this.currentForm.get(this.formFieldName);
    
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
